import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import {
  toDollarAmountOrDash,
  contribInvestmentAmtText
} from '../FONASUCustomerInformation/util';
import styles from '../FONASUCustomerInformationSection/FONASUCustomerInformationSection.css';
import { currentYear, priorYear } from '../../flows/shared/dateUtils';

const FONASUContribInvestmentReview = ({
  currentYearAmount,
  priorYearAmount,
  totalInvestmentAmt,
  contributionLimits
}) => {
  const {
    currentYearMaximumLimit,
    currentYearContributionsSoFar,
    currentYearRemainingContributions,
    priorYearMaximumLimit,
    priorYearContributionsSoFar,
    priorYearRemainingContributions,
    withinIRAPriorYearContributionPeriod
  } = contributionLimits;

  return (
    <>
      <div className="section-header">
        <SectionHeading text="Investment Amount" />
      </div>
      <div className="review-section">
        {withinIRAPriorYearContributionPeriod && (
          <div className="qv-row">
            <div className="qv-col">
              <div className="field-label">
                {priorYear} IRA Contribution Limit
              </div>
              <div className="field-value">
                {toDollarAmountOrDash(priorYearMaximumLimit)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">Your contribution to date*</div>
              <div className="field-value">
                {toDollarAmountOrDash(priorYearContributionsSoFar)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">Contribution amount remaining</div>
              <div className="field-value">
                {toDollarAmountOrDash(priorYearRemainingContributions)}
              </div>
            </div>
            <div className="qv-col">
              <div className="field-label">{priorYear} IRA Contributions</div>
              <div className="field-value">
                ${Number(priorYearAmount).toLocaleString('en-US')}
              </div>
            </div>
          </div>
        )}
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">
              {currentYear()} IRA Contribution Limit
            </div>
            <div className="field-value">
              {toDollarAmountOrDash(currentYearMaximumLimit)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Your contribution to date*</div>
            <div className="field-value">
              {toDollarAmountOrDash(currentYearContributionsSoFar)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Contribution amount remaining</div>
            <div className="field-value">
              {toDollarAmountOrDash(currentYearRemainingContributions)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">{currentYear()} IRA Contributions</div>
            <div className="field-value">
              ${Number(currentYearAmount).toLocaleString('en-US')}
            </div>
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">{contribInvestmentAmtText}</div>
          {withinIRAPriorYearContributionPeriod && (
            <div className="qv-col">
              <div className="field-label">New Investment Amount Total </div>
              <div className="field-value">
                ${Number(totalInvestmentAmt).toLocaleString('en-US')}
              </div>
            </div>
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FONASUContribInvestmentReview;
